<template>
    <div class="right-body" id="rightBodyList" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0)" @click="filterMenuClose">
        <div class="right-body-box" :style="showBatchDel?'height: calc(100% - 91px);':''" v-loading="" element-loading-background="rgba(0, 0, 0, 0.05)">
            <!-- 功能区 -->
            <div class="task-list-functions">
                <!-- 删除状态按钮 -->
                <div class="icon-function delete" :class="showBatchDel?'delete-red':'delete'" @click="changeBatchDel()" v-if="taskListOriginal.length>5"></div>
                <!-- 筛选 -->
                <div class="icon-function funnel" @click.stop="filterMenuShow=true" v-if="taskListOriginal.length>5"  v-rightclickoutside="dateControlsClose">
                    <div class="screen-options filter-menu" :style="lang == 'jp'?'right:-20px;width:130px;':''" v-if="filterMenuShow">
                        <div class="screen-option filter-menu-item" v-for="(menu,index) in filterMenu" :key="index" @mouseenter="switchMenu(index)" @click.stop="switchMenu(index)" >
                            <div class="icon-util filter-triangle filter-triangle-position"></div>
                            {{$t('language.filters.taskList.'+menu.name)}}
                            <div class="type-menu" :style="lang == 'jp'?'right:130px;':''" v-if="(filterIndex-1)==(index)">
                                <div v-for="type in menu.children" :key="type.id" class="type-menu-item" @click.stop="chickFilterState(index+1,type.id)">
                                    <div class="icon-util tick-purple-position" :class="{'tick-purple':filterState==type.id}" v-if="index==0"></div>
                                    <div class="icon-util tick-purple-position" :class="{'tick-purple':filterDate==type.id}" v-else></div>
                                    <div class="filter-type-name">{{$t('language.filters.taskList.'+type.name)}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 自定义时间 -->
                    <div class="time-set" v-if="timeSetShow" @click.stop="" v-clickoutside="dateControlsClose">
                        <date-selector ref="freeFilterDate" style="margin:8Px 8Px 8Px 10Px;/*no*/"></date-selector>
                        <button class="time-set-button" @click.stop="saveTimeFilter()">{{$t('language.common.ok')}}</button>
                    </div>
                </div>
                <!-- 表格列表切换 -->
                <div class="task-list-switch-tab" v-if="taskListOriginal.length>0">
                    <div class="icon-switch-tab" :class="{'icon-switch-tab-this':listContentShow==1}">
                        <!-- 显示表格 -->
                        <div class="" @click="changelistContentShow(1)" :data-title="$t('language.cloudExploer.grid')" :class="listContentShow==1?'list-white':'list'"></div>
                    </div>
                    <div class="icon-switch-tab" :class="{'icon-switch-tab-this':listContentShow==2}">
                        <!-- 显示列表 -->
                        <div class="" @click="changelistContentShow(2)" :data-title="$t('language.cloudExploer.pageList')" :class="listContentShow==2?'grid-white':'grid'"></div>
                    </div>
                </div>
            </div>
            <!-- tab区 -->
            <div style="height:100%;">
                <!-- tab标题集合 -->
                <div class="task-list-tab-titles">
                    <div v-for="type in tabTitleTypes" :key="type.id">
                        <div class="task-list-tab-title" :class="{'tab-this':filterType==type.id}" v-if="type.id==100?true:(tabTitleShowNum>2?type.haveTask:false)">
                            <div @click="chickFilterState(0,type.id)">
                                {{$t('language.filters.taskList.'+type.name)}}
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 任务列表loading加载状态 -->
                <div class="task-list-initial" v-if="isLoading" :class="(!haveTaskData||filteredList.length)?'':'task-filter-none'">
                    <div class="loading-img" v-loading="isLoading"></div>
                    <strong>{{$t('language.common.load')}}</strong>
                    <span>{{$t('language.taskList.loadingTip')}}</span>
                </div>
                <!-- 无任务状态 有任务但是筛选导致没有的需要显示白底 -->
                <div class="task-list-initial" v-show="!haveTaskData||!filteredList.length" :class="(!haveTaskData||filteredList.length)?'':'task-filter-none'">
                    <img src="../../assets/images/task-icon/no_task_bg.png">
                    <strong>{{$t('language.taskList.noTasks')}}</strong>
                    <span v-if="taskListOriginal.length<1">{{$t('language.taskList.noTasksTip')}}</span>
                </div>
                <!-- tab内容 -->
                <div class="task-list-tab-content" v-show="haveTaskData">
                    <!-- 表格区 -->
                    <div class="task-list-grid" v-if="listContentShow==1" ref="tasksCards">
                        <el-checkbox v-if="showBatchDel" style="height: 32px;" :indeterminate="isDeleteAll" v-model="deleteCheckAll" @change="deleteHandleCheckAllChange">{{$t('language.taskList.allTasks',{num:filteredList.length})}}</el-checkbox>
                        <!-- 任务容器 -->
                        <el-checkbox-group v-model="checkDeleteList" :class="showBatchDel?'batchDel':''">
                            <el-row type="flex" justify="start" class="task-grid-cards">
                                <singelTaskCard v-for="(task,index) in showList" :key="index" :item=task :collapseFlage=collapseFlage :eidtTaskFlag='eidtTaskFlag' :detailShow=detailShow :index=index :tasklistData='filteredList' @open-function-popup="openFunctionPopup" @execute-task="executeTask" @pause-task="cancelOrPauseTask" @to-source="toSourceCatalog" @to-aim="toAimCatalog"></singelTaskCard>
                            </el-row>
                        </el-checkbox-group>
                    </div>
                    <!-- 列表区 -->
                    <singelTaskForm ref="singelTaskForm" :tasklistData='filteredList' :listContentShow=listContentShow :showBatchDel=showBatchDel :checkDeleteList=checkDeleteList @open-function-popup="openFunctionPopup" @execute-task="executeTask" @pause-task="cancelOrPauseTask"></singelTaskForm>
                </div>
            </div>
            <div class="task-buttom"></div>
        </div>
        <!-- 删除任务确认框 -->
        <deleteBtns ref="deleteBtns" :deleteList=checkDeleteList :showBatchDel=showBatchDel :showDelBtn=showDelBtn></deleteBtns>

        <viewLogsDialog ref="viewLogsDialog"></viewLogsDialog>
        <transferOptionsDialog ref="transferOptionsDialog"></transferOptionsDialog>
        <emailTransferOptionsDialog ref="emailTransferOptionsDialog"></emailTransferOptionsDialog>
        <syncOptionsDialog ref="syncOptionsDialog"></syncOptionsDialog>
        <viewBackupLogsDialog ref="viewBackupLogsDialog"></viewBackupLogsDialog>
        <backupOptionDialog ref="backupOptionDialog"></backupOptionDialog>
        <backupRestoreDialog ref="backupRestoreDialog"></backupRestoreDialog>
        <versionsDialog ref="versionsDialog"></versionsDialog>
        <deleteTaskDialog ref="deleteTaskDialog"></deleteTaskDialog>
        <deleteSelectedTaskDialog ref="deleteSelectedTaskDialog" :deleteList=checkDeleteList @refresh-all="refreshTaskList"></deleteSelectedTaskDialog>
        <transferScheduleDialog ref="transferScheduleDialog" @update="updateOptionRequest" @upgrade="showUpgrade"></transferScheduleDialog>
        <upgradeDialog ref="upgradeDialog"></upgradeDialog>
        <taskMultiSourcesDialog ref="taskMultiSourcesDialog" @to-source-catalog="toSourceCatalog" @to-aim-catalog="toAimCatalog"></taskMultiSourcesDialog>
        <deleteAttentionDialog ref="deleteAttentionDialog"></deleteAttentionDialog>

        <failedFilesDialog ref="failedFilesDialog"></failedFilesDialog>
        <!-- <addEmialNoticeDialog ref="addEmialNoticeDialog"></addEmialNoticeDialog> -->
        <taskProgressDialog ref="taskProgressDialog"></taskProgressDialog>
        <!-- 运行中任务 获取进度 控制模组 -->
        <taskListProgressControlModule ref="taskListProgressControlModule" :taskList=taskListOriginal @refresh-all="refreshTaskList"></taskListProgressControlModule>
    </div>
</template>

<script>
import Vue from 'vue';
import '@/assets/css/clouds_logo.css';
import "@/assets/css/task_list_icon.css";

import commonstate from '@/js/constant.js';
import commonUtils from "@/js/workspace/common_util.js";
import taskFilter from "@/js/workspace/task_list_filters.js";
import dateSelector from "@/components/common/selector/date_selector";
import taskListUtils from "@/js/workspace/task_list_util.js";
import singelTaskCard from "@/components/common/tabs/tabs_task_list/tabs_single_task_card";
import singelTaskForm from "@/components/common/tabs/tabs_task_list/tabs_single_task_form";
import deleteBtns from "@/components/common/tabs/tabs_task_list/tabs_delete_btns";

import transferOptionsDialog from "@/components/popup/task_list_popups/task_transfer_options_popup";
import emailTransferOptionsDialog from "@/components/popup/task_list_popups/task_email_transfer_options_popup";
import syncOptionsDialog from "@/components/popup/task_list_popups/task_sync_options_popup";
import backupOptionDialog from "@/components/popup/task_list_popups/backup_list_options_popup";
import deleteAttentionDialog from "@/components/popup/task_list_popups/delete_version_attention_popup";
//弹窗相关
// import viewLogsDialog from "@/components/popup/task_list_popups/view_logs_popups";
import viewLogsDialog from "@/components/popup/task_list_popups/view_logs_popup";
import viewBackupLogsDialog from "@/components/popup/task_list_popups/view_backup_logs_popups";
import backupRestoreDialog from "@/components/popup/task_list_popups/backup_restore_popup";
import versionsDialog from '@/components/popup/task_list_popups/list_versions_popup';
import deleteTaskDialog from "@/components/popup/task_list_popups/delete_task_popups";
import transferScheduleDialog from "@/components/popup/task_list_popups/task_list_schedule_popup";
import taskProgressDialog from "@/components/popup/task_list_popups/task_progress_popup";//显示账号升级弹窗

import deleteSelectedTaskDialog from "@/components/popup/task_list_popups/delete_selected_tasks_popups";
import upgradeDialog from "@/components/popup/upgrade_popups/upgrade_account_new_popup";

import taskMultiSourcesDialog from "@/components/popup/task_list_popups/task_multi_sources_popup";

import failedFilesDialog from "@/components/popup/task_list_popups/view_failed_files_popup";
// import addEmialNoticeDialog from '@/components/popup/remote_task_popups/add_email_notice_popup';

import cloudExploerUtils from "@/js/workspace/cloud_exploer_util.js";

import taskListConvert from "@/js/workspace/task_list_convert.js";

import taskListProgressControlModule from "@/components/common/controller/task_list_progress_control";

export default {
    name: 'taskList',
    components: {
        taskFilter,
        "date-selector": dateSelector,
        singelTaskCard,
        singelTaskForm,
        deleteBtns,
        viewLogsDialog,
        transferOptionsDialog,
        emailTransferOptionsDialog,
        syncOptionsDialog,
        viewBackupLogsDialog,
        backupOptionDialog,
        backupRestoreDialog,
        versionsDialog,
        deleteTaskDialog,
        deleteSelectedTaskDialog,
        transferScheduleDialog,
        upgradeDialog,
        failedFilesDialog,
        // addEmialNoticeDialog,
        taskMultiSourcesDialog,
        deleteAttentionDialog,
        taskProgressDialog,
        taskListProgressControlModule
    },
    data: function () {
        return {
            user: commonUtils.getUser(),
            loading:false,
            haveTaskData: false,//展示任务列
            showDeleteState: false,//是否开启删除状态
            taskListOriginal: [],//初始任务列表
            taskListNoGropArr: [],//初始任务列表
            tabTitleTypes: [],//标签类型集合
            tabTitleShowNum: 1,//总共需要展示几个标签
            filterMenu: [],//筛选菜单列表
            filterMenuShow: false,//筛选菜单是否开启
            filterIndex: 0,//过滤上级菜单： 0：无，1：状态选中，2：日期选中
            filterType: 100,//类型过滤规则
            filterState: 200,//状态过滤规则
            filterDate: 300,//日期过滤规则
            freeFilterDateList: [],//自定义时间范围
            timeSetShow: false,//自定义时间是否开启
            listContentShow: 1,//当前展示列表形式：1：表格，2：列表
            openOptionMenuIndex: -1,//确保功能下拉框打开的唯一性
            collapseFlage: -1,
            eidtTaskFlag: false,
            detailShow: false,
            checkDeleteList: [],//批量删除集合
            showBatchDel: false,//是否打开批量删除
            showDelBtn: false,//是否显示底部删除按钮
            isDeleteAll: false,
            deleteCheckAll: false,
            unfinishedArr: ["Cancel", "cancel", "error"],
            schedules: [],//定时任务键值对 id:最近执行时间
            nextRefreshTime: new Date().getTime(),//下次刷新时间，用于判断是否需要自动刷新页面，用于长时间无运行任务状态，页面激活时进行任务刷新
            executeFlag: true,
            switchTypeFlag: true,
            isLoading: false,//任务列表加载状态
            lang: commonUtils.getLocaleToIndex(localStorage.getItem("locale")),
            pageIndex: 1,//瀑布流加载页数
            pageSize: 30,//瀑布流加载每页任务数
        }
    },
    created () {
        //处理筛选项
        const filterMenu = taskFilter.init(0);
        //类型筛选项
        const typeIndex = filterMenu.findIndex(item => item.id === 1);
        if(typeIndex>-1) {
            this.tabTitleTypes = filterMenu.splice(typeIndex,1)[0].children;
        }
        //其他筛选项
        this.filterMenu = filterMenu;
        
    },
    mounted() {
        //初始化列表
        console.log("start init")
        this.isLoading = true;
        this.initTaskListPage();
        
        var taskListState = this.$cookies.get("taskListState" + this.user.id);
        if(taskListState){
            this.listContentShow = taskListState;
        }else {
            this.$cookies.set("taskListState" + this.user.id,this.listContentShow,"1y");
        }

        window.addEventListener('scroll', this.handleScroll,true);
    },
    beforeDestroy() {
        clearTimeout(this.schedulesTimer);
        window.removeEventListener('scroll', this.handleScroll);
    },
    activated() {
        this.initOptions();
    },
    watch: {
        '$store.state.taskListArr': function (newValue, oldValue) {
            if (!newValue.length) {
                //如果没有新数据就显示另一个界面
                this.haveTaskData = false;
                this.taskListOriginal = [];
            } else {
                //显示任务列表
                this.haveTaskData = true;
                this.initTaskListPage();
            }
        },
        // '$store.state.taskListNotGropArr': function (newValue, oldValue) {
        //     //如果有新加入任务，则加入列表并置空未分组
        //     if (newValue.length) {
        //         var grops = [];
        //         newValue.forEach(task => {
        //             grops.push(taskListConvert.initNewTask(task))
        //         });
        //         let newGrops = this.taskListOriginal.concat(grops);
        //         newGrops.sort(taskListUtils.sortCreateTime);
        //         this.taskListOriginal = newGrops;
        //         this.$store.commit("setTaskListNotGropArr", []);
        //     }
        // },
        taskListOriginal: {
            handler: function (newValue, oldValue) {
                //提前判断所有类型的任务数组
                var that = this;
                var showNum = 1;
                this.tabTitleTypes.forEach((item) => {
                    if(item.id == 100){
                        item.haveTask = true;
                    }else if(!newValue||newValue.length<1) {
                        //如果当前没有任务了,返回all
                        item.haveTask = false;
                        that.chickFilterState(0,100);
                    }else {
                        let list = taskFilter.filter(newValue,item.id,{});
                        if(list.length>0){
                            item.haveTask = true;
                            showNum++;
                        }else {
                            item.haveTask = false;
                            if(item.id == that.filterType){
                                //如果当前显示的任务是空的，则返回all
                                that.chickFilterState(0,100);
                            }
                        }
                    }
                });
                this.tabTitleShowNum = showNum;
            },
        },
        // showBatchDel: {
        //     handler: function (newValue, oldValue) {
        //         if(!newValue){
        //             this.checkDeleteList = [];
        //         }
        //     },
        // },
        checkDeleteList: {
            handler: function (newValue, oldValue) {
                if(newValue&&newValue.length>0){
                    if(this.listContentShow == 1){
                        this.deleteHandleCheckedTasksChange(newValue);
                    }
                }else {
                    //删除后情况列表，则关闭多选删除状态
                    if(!this.showDelBtn){
                        this.showBatchDel = false;
                        this.isDeleteAll = false;
                        this.deleteCheckAll = false;
                    }
                    if(this.listContentShow == 2 && this.$refs.singelTaskForm.$refs.multipleTable) {
                        //列表模式取消选中效果
                        this.$refs.singelTaskForm.$refs.multipleTable.clearSelection();
                    }
                }
            },
        },
        filteredList: {
            handler: function (newValue, oldValue) {
                //同步删除列表
                this.syncDelListInBacthDel();
                //重置页数
                this.pageIndex = 1;
            },
        }
    },
    methods: {
        //初始化参数
        initOptions() {
            //清除删除状态
            this.showDelBtn = false;
            this.checkDeleteList = [];
            this.isDeleteAll = false;
            //还原筛选参数
            this.filterMenuShow = false;
            this.filterIndex = 0;
            this.filterType = 100;
            this.filterState = 200;
            this.filterDate = 300;
        },
        //瀑布流加载监听
        handleScroll() {
            if(this.$refs.tasksCards&&this.$refs.tasksCards.scrollTop) {
                let scrollTop = this.$refs.tasksCards.scrollTop;
                let clientHeight = this.$refs.tasksCards.clientHeight;
                let scrollHeight = this.$refs.tasksCards.scrollHeight;
                console.log(scrollTop,clientHeight,scrollHeight)
                if ((scrollTop + clientHeight) >= (scrollHeight - 50)) {
                    if(this.filteredList.length > (this.pageIndex * this.pageSize)) {
                        this.pageIndex++;
                    }
                }
            }
        },
        //卡片全选需要删除的任务
        deleteHandleCheckAllChange(val) {
            if(val){
                //合并集合并去重
                const nowList = this.filteredList.map((task) => {return task.id});
                const allList = [...this.checkDeleteList, ...nowList];
                this.checkDeleteList = [...new Set(allList)];
            }else{
                //移除集合取差集
                this.checkDeleteList = [...this.checkDeleteList].filter(x => [...this.filteredList].every(y => y.id != x));
            }
            this.isDeleteAll = false;
        },
        //卡片选择需要删除的任务
        deleteHandleCheckedTasksChange(value) {
            const nowList = this.filteredList.map((task) => {return task.id});
            //判断删除集合是否全包含
            const isDelAll = nowList.every(item => value.includes(item));
            this.deleteCheckAll = isDelAll;
            //判断删除集合是否包含当前页面的任务
            if(isDelAll) {
                this.isDeleteAll = false;
            }else {
                const delAllSet = new Set(value);
                const isDelNow = nowList.some(item => delAllSet.has(item));
                this.isDeleteAll = isDelNow;
            }
        },
        //多选删除状态下切换筛选条件或显示方式时，用于同步显示删除列表信息
        syncDelListInBacthDel() {
            if(this.showBatchDel){
                //删除状态变更筛选条件需要判断是否全选
                if(this.listContentShow == 1){
                    this.deleteHandleCheckedTasksChange(this.checkDeleteList);
                }else if(this.listContentShow == 2){
                    //控制列表和卡片同步
                    //切换源时重置
                    let otherDelList = [];
                    let nowDelList = [];//保存对象
                    let newValue = this.filteredList;
                    this.checkDeleteList.forEach(function(id) {
                        let item = newValue.find(task => task.id === id);
                        if(item) {
                            //当前数据源包含被选中对象
                            nowDelList.push(item);
                        }else{
                            //其他源被选中数据
                            otherDelList.push(id);
                        }
                    });
                    //保存其他源删除数组信息
                    this.$refs.singelTaskForm.otherDelList = otherDelList;
                    //如果当前源有被选中的数据，则自动选中
                    if(nowDelList.length>0) {
                        this.$nextTick(() => {
                            //选中数据
                            nowDelList.forEach(nowDel => {
                                this.$refs.singelTaskForm.$refs.multipleTable.toggleRowSelection(nowDel, true);
                            });
                        });
                    }
                }
            }
        },
        //切换卡片或列表
        changelistContentShow(state) {
            this.listContentShow = state;
            //同步删除列表
            this.syncDelListInBacthDel();
            this.$cookies.set("taskListState" + this.user.id,state,"1y");
        },
        //切换多选删除按钮
        changeBatchDel() {
            this.showBatchDel = !this.showBatchDel;
            this.showDelBtn = this.showBatchDel;
            if(!this.showBatchDel){
                //如果是关闭,需要清除数据
                this.checkDeleteList = [];
            }
        },
        //初始化任务列表
        initTaskListPage() {
            //处理数据
            var that = this;
            taskListConvert.initTaskList({ud:commonUtils.getUser().id,type:2},function(res){
                that.taskListOriginal = res;
                that.isLoading = false;
                if(that.taskListOriginal&&that.taskListOriginal.length>0){
                    that.haveTaskData = true;
                }
            });
            // this.taskListOriginal = this.conversionTaskList(Object.assign([], this.$store.state.taskListArr));
                console.log(this.taskListOriginal)
        },
        //重新初始化
        refreshTaskList(isLoading) {
            console.log("refresh!!!");
            if(isLoading) {
                this.isLoading = true;
            }
            this.initTaskListPage();
        },
        //获取来源或目标的显示名称
        getTaskItemsName(item) {
            let itemName;
            if(item) {
                let firstItem;
                if(item.data){
                    //多源使用第一个源
                    firstItem = item.data[0];
                }else{
                    firstItem = item;
                }
                if(firstItem.name){
                    itemName = firstItem.name;
                }else if(firstItem.fileName) {
                    itemName = firstItem.fileName;
                }else if(firstItem.filename) {
                    itemName = firstItem.filename;
                }
            }
            return itemName
        },
        //筛选选中
        switchMenu (index) {
            this.filterIndex = index + 1;
        },
        chickFilterState (index,ruleId) {
            switch (index) {
                case 0:
                    this.filterType = ruleId;
                    break;
                case 1:
                    this.filterState = ruleId;
                    break;
                case 2:
                    if(ruleId==304){
                        //打开自定义弹窗
                        this.timeSetShow = true;
                        this.$nextTick(() => {
                            this.reSet();
                        });
                    }else {
                        this.filterDate = ruleId;
                    }
                    break;
                default:
                    break;
            }
            //选择后关闭弹窗
            this.filterMenuClose();
        },
        //重置时间选择
        reSet () {
            console.log(this.freeFilterDateList)
            if(this.freeFilterDateList.length>0) {
                this.$refs.freeFilterDate.date = this.freeFilterDateList;
            }else {
                var date = new Date();
                let year = date.getFullYear();
                let Month = date.getMonth() + 1;
                let day = date.getDate();
                let res = year + '-' + Month + '-' + day;
                this.$refs.freeFilterDate.date = [res,res];
            }
        },
        //保存日期筛选信息
        saveTimeFilter() {
            //设置筛选为日期筛选
            this.filterDate = 304;
            //保存当前选中数据
            console.log(this.$refs.freeFilterDate.date)
            this.freeFilterDateList = this.$refs.freeFilterDate.date;
            this.dateControlsClose();
            this.filterMenuClose();
        },
        //关闭日期选择
        dateControlsClose () {
            this.timeSetShow = false;
        },
        //关闭过滤菜单
        filterMenuClose () {
            this.filterMenuShow = false;
            this.filterIndex = 0;
        },
        //把时间转换为long类型
        conversionLongTime (time) {
            var date = new Date(time);
            let res = date.getTime();
            return res;
        },
        //转换第二天时间
        conversionMaxLongTime (time) {
            var date = new Date(time);
            date.setDate(date.getDate() + 1);
            let res = this.conversionLongTime(date);
            return res;
        },
        //接收并处理任务单体的打开弹窗请求
        openFunctionPopup(type,task) {
            var that = this;
            console.log('openPopup',type)
            switch (type) {
                case 1:
                    that.viewLogsOpen(task);
                    break;
                case 2:
                    that.openOptionsDialog(task);
                    break;
                case 3:
                    that.deleteTaskItems(task);
                    break;
                case 4:
                    that.openBackupRestore(task);
                    break;
                case 5:
                    that.openVersions(task);
                    break;
                case 6:
                    that.openProgressPopup(task);
                    break;
                case 7:
                    that.openSchduleDialog(task);
                    break;
                case 8:
                    that.openSourceList(task);
                    break;
                // case 'openEmialNoticeDialog':
                //     that.openEmialNoticeDialog(task);
                //     break;
                default:
                    break;
            }
        },
        // openEmialNoticeDialog(task) {
        //     this.$refs.addEmialNoticeDialog.openByTask(this.user.email,task);
        // },
        //打开进度弹窗
        openProgressPopup(task) {
            if(task.type == 1 || task.type == 6 ) {
                this.$refs.taskProgressDialog.initPage(task.id);
            }
        },
        //打开任务列表多源或多目标，源或目标信息展开列表页面
        openSourceList(task) {
            console.log(task)
            if(task.fromItem.lists.length>1){
                this.$refs.taskMultiSourcesDialog.initDate(task.fromItem.lists,1,task.taskType);
            }else if(task.toItem.lists.length>1) {
                this.$refs.taskMultiSourcesDialog.initDate(task.toItem.lists,2,task.taskType);
            }
        },
        //打开删除单个任务弹窗
        deleteTaskItems(task) {
            this.$refs.deleteTaskDialog.deleteTaskShow = true;
            this.$refs.deleteTaskDialog.deleteItem = task;
        },
        //打开删除所有任务弹窗
        deleteAllItem () {
            this.$refs.deleteSelectedTaskDialog.deleteSelectedTaskShow = true;
        }, 
        //打开设置弹窗
        openOptionsDialog(item) {
            let that = this;
            let tab1 = this.$refs.syncOptionsDialog.$refs.tab1;
            var index = this.taskListOriginal.findIndex(t => t.id === item.id);
            let taskDialog;
            if (item.type == 1) { //
                if(item.lowerType == 106){
                    //如果是邮件传输
                    taskDialog = this.$refs.emailTransferOptionsDialog;
                    //显示第一页
                    taskDialog.item = item;
                    taskDialog.itemIndex = index;
                    taskDialog.optionDialogShow = true;
                    taskDialog.options = Object.assign({}, item.options);
                    //配置tab-transfer界面显示系统中已有的数据 
                    let value = taskDialog.caseOption(parseInt(item.options.replace));
                    taskDialog.$refs.tab1.$refs.cloudSelect.currentValue = value;
                    taskDialog.$refs.tab1.isChar = item.options.isChar;
                    // taskDialog.$refs.tab1.isRemove == item.options.isRemove;
                    // taskDialog.$refs.tab1.isKeep == item.options.isKeep;
                    // taskDialog.$refs.tab1.keepRoot == item.options.keepRoot;
                    taskDialog.$refs.tab1.isSaveAtt = item.options.attachment;
                    taskDialog.$refs.tab1.isConver = item.options.conversationQuoted;
                    taskDialog.$refs.tab1.isSaveOnly = item.options.onlyLastMail;
                    taskDialog.$refs.tab1.delWatermark = item.options.delWatermark;
                }else{
                    this.$refs.transferOptionsDialog.activeName = "first";
                    taskDialog = this.$refs.transferOptionsDialog;
                    taskDialog.item = item;
                    taskDialog.itemIndex = index;
                    taskDialog.optionDialogShow = true;
                    taskDialog.options = Object.assign({}, item.options);
                    //配置tab-transfer界面显示系统中已有的数据 
                    let value = taskDialog.caseOption(parseInt(item.options.replace));
                    taskDialog.$refs.tab1.$refs.cloudSelect.currentValue = value;
                    taskDialog.$refs.tab1.checkArr = [];
                    if (item.options.isChar == 1) {
                        taskDialog.$refs.tab1.checkArr.push(2);
                    }
                    if (item.options.isRemove == 1) {
                        taskDialog.$refs.tab1.checkArr.push(0);
                    }
                    if (item.options.isKeep == 1) {
                        taskDialog.$refs.tab1.checkArr.push(1);
                    }
                    if (item.options.keepRoot == 1) {
                        taskDialog.$refs.tab1.checkArr.push(3);
                    }
                    if (item.options.newTrans == 1) {
                        taskDialog.$refs.tab1.checkArr.push(4);
                    }
                    this.$refs.transferOptionsDialog.$refs.tab1.oldCheckArr = this.$refs.transferOptionsDialog.$refs.tab1
                    .checkArr;
                }
            }
            if (item.type == 6) {
                this.$refs.backupOptionDialog.activeName = "second";
                taskDialog = this.$refs.backupOptionDialog;
                taskDialog.item = item;
                taskDialog.itemIndex = index;
                taskDialog.backupOptionDialogShow = true;
                taskDialog.options = Object.assign({}, item.options);
            }
            if (item.type == 2 || item.branchType == 'realtime') {
                this.$refs.syncOptionsDialog.activeName = "first";
                taskDialog = this.$refs.syncOptionsDialog;
                this.$refs.syncOptionsDialog.item = item;
                this.$refs.syncOptionsDialog.itemIndex = index;
                this.$refs.syncOptionsDialog.syncOptionShow = true;
                taskDialog.options = Object.assign({}, item.options);
                //配置tab-sync界面显示系统中已有的数据
                that.$refs.syncOptionsDialog.caseOption(parseInt(item.options.way));
                that.$refs.syncOptionsDialog.chooseChar(parseInt(item.options.isChar));
                that.$refs.syncOptionsDialog.oldOptions = item.options;
                if (item.branchType == 'realtime') {
                    tab1.$refs.selectrealTime.currentValue = this.$t('language.cloudSync.realTimeSync');
                    if (parseInt(item.options.way) == 20) {
                        tab1.selectOption = [{
                            name: this.$t('language.cloudSync.oneWaySimple'),
                            id: 0
                        }];
                    } else {
                        tab1.$refs.selectOne.currentValue = this.$t('language.cloudSync.oneWaySimple');
                        tab1.selectOption = [{
                            name: this.$t('language.popup.twowaySync'),
                            id: 1
                        }];
                    }
                    tab1.selectTwoShow = false; //不显示第三项
                } else {
                    tab1.$refs.selectrealTime.currentValue = this.$t('language.cloudSync.normalSync');
                    tab1.selectOptionTwo = this.$refs.syncOptionsDialog.$refs.tab1.selectOptionTwoAll;
                }
                if (item.options.way == 10 && item.sources) { //如果是多源单向同步，只能选择简单同步
                    this.$nextTick(() => {
                        tab1.selectOption = [];
                        tab1.$refs.selectOne.selectLength = [];
                        tab1.$forceUpdate();
                    });
                }
            }
            if (item.sources && item.sources.length && item.branchType != 'realtime') {
            tab1.listNormalOpen = true;
            tab1.$refs.selectrealTime.listNormalOpen = true;
            }
            //配置tab-email界面显示系统中已有的数据
            if (item.options.email) {
                taskDialog.$refs.tab2.sendShow = true;
                taskDialog.$refs.tab2.email = item.options.email;
            } else {
                taskDialog.$refs.tab2.sendShow = false;
                taskDialog.$refs.tab2.email = '';
            }
            this.$nextTick(() => {
                tab1.$refs.selectrealTime.setInputWidth();
            });
            //配置tab-filter界面显示系统中已有的数据
            if(item.options.way != 'cloudEmail'){
                if (item.options.pattern == 'include' || item.options.pattern == 'exclude') {
                    if (item.options.pattern == 'include') {
                        taskDialog.$refs.tab3.radioCurrent = 1;
                        taskDialog.$refs.tab3.items = [];
                        taskDialog.$refs.tab3.includeArr = [];
                        let matchedArr = item.options.matched.split("|");
                        $.each(matchedArr, function(i, item) {
                            let filterValue = commonUtils.matchExtension(commonUtils.getSuffix(item));
                            taskDialog.$refs.tab3.items.push(filterValue);
                            taskDialog.$refs.tab3.includeArr.push(filterValue);
                        })
                    }
                    if (item.options.pattern == 'exclude') {
                        taskDialog.$refs.tab3.radioCurrent = 0;
                        taskDialog.$refs.tab3.items = [];
                        taskDialog.$refs.tab3.ignoreArr = [];
                        let matchedArr = item.options.matched.split("|");
                        $.each(matchedArr, function(i, item) {
                            let filterValue = commonUtils.matchExtension(commonUtils.getSuffix(item));
                            taskDialog.$refs.tab3.items.push(filterValue);
                            taskDialog.$refs.tab3.ignoreArr.push(filterValue);
                        })
                    }
                } else {
                    taskDialog.$refs.tab3.radioCurrent = 0;
                    taskDialog.$refs.tab3.items = [];
                    taskDialog.$refs.tab3.includeArr = [];
                    taskDialog.$refs.tab3.ignoreArr = [];
                }
            }
        },
        //打开备份任务版本信息弹窗
        openVersions(item) {
            this.$refs.versionsDialog.versionShow = true;
            let that = this;
            //优先置空
            that.$refs.versionsDialog.versions = null;
            that.$refs.versionsDialog.backupRoot = null;
            that.$refs.versionsDialog.task = item;
            let getData = new taskListUtils.getTasks(commonUtils.getUser().id, item.type, item.id, item.groupId);
            this.Utils.doTasksRequest("list_versions", getData).then(result => {
                if (result.backup_versions.length) {
                    that.$refs.versionsDialog.notRunShow = false;
                    result.backup_versions.sort(taskListUtils.sortCreateTime);
                    that.$refs.versionsDialog.versions = result.backup_versions;
                    that.$refs.versionsDialog.backupRoot = result.backup_backupRoot;
                    that.$refs.versionsDialog.task = item;
                    $.each(that.$refs.versionsDialog.versions, function(j, jItem) {
                        jItem.taskId = item.id;
                    });
                } else {
                    that.$refs.versionsDialog.notRunShow = true;
                }
            });
        },
        //打开备份还原弹窗
        openBackupRestore(item,value) {
            let that = this;
            let dialog = this.$refs.backupRestoreDialog;
            dialog.selecTimeValue = '';
            dialog.$refs.selectOne.currentValue = '';
            let getData = new taskListUtils.getTasks(commonUtils.getUser().id, item.type, item.id, item.groupId);
            this.Utils.doTasksRequest("list_versions", getData).then(result => {
                if (result.backup_versions.length) {
                    dialog.restoreShow = true;
                    dialog.stepOne = true;
                    dialog.loading = true;
                    dialog.onChangeOptionType(this.$t('language.cloudBackup.keepLatest'));
                    let array = result.backup_versions;
                    //将array通过里面的createTime从新到旧进行排序
                    array.sort(taskListUtils.sortCreateTime);
                    dialog.versions = array;
                    dialog.itemIndex = that.taskListOriginal.findIndex(task => task.id == item.id);
                    dialog.selectTimeOption = [];
                    dialog.timeOptionAll = [];
                    dialog.catalogModel = [];
                    let firstItem;
                    console.log(array)
                    for (let index = 0; index < array.length; index++) {
                        if (index == 0) {
                            dialog.selecTimeValue = commonUtils.transferForMatTime(array[index].createTime);
                            dialog.$refs.selectOne.currentValue = dialog.selecTimeValue;
                            firstItem = {
                                name: dialog.selecTimeValue,
                                bId: array[index].id,
                                backupId: array[index].backupId,
                                versionNum: array[index].versionNum,
                                icon: false,
                                id: 0
                            }
                        } else {
                            let item = commonUtils.transferForMatTime(array[index].createTime);
                            dialog.selectTimeOption.push({
                                name: item,
                                backupId: array[index].backupId,
                                bId: array[index].id,
                                versionNum: array[index].versionNum,
                                icon: false,
                                id: index
                            });
                        }
                        if (index == array.length - 1) {
                            dialog.timeOptionAll = dialog.selectTimeOption;
                            if (firstItem) {
                                dialog.timeOptionAll.unshift(firstItem);
                            }
                        }
                    }
                    if (value) {
                        dialog.$refs.selectOne.currentValue = commonUtils.transferForMatTime(value);
                    }
                    that.listRestoreCatalog(item,result, function(res) {});
                } else { //如果没有返回版本信息再调用taks/get
                    delete getData.s;
                    this.Utils.doTasksRequest("get", getData).then(result => {
                    if (result.status == 200) {
                        if (result.tasks[0].lastLog) {
                            that.openRestoreFlag = true;
                            that.$toast({
                                text: that.$t('language.cloudBackup.notRestore'),
                                type: 'fail',
                                idValue: "rightBodyList"
                            });
                        } else {
                            let dialog = that.$refs.backupRestoreDialog;
                            dialog.restoreShow = true;
                            dialog.stepOne = true;
                            dialog.execute = false;
                            that.openRestoreFlag = true;
                        }
                    }
                    });
                }
            });
        },
        //列出还原目录
        listRestoreCatalog(item,value, callback) {
            let dialog = this.$refs.backupRestoreDialog;
            dialog.loading = false;
            dialog.isSources = false;
            if (item.fromItem.data && item.fromItem.data.length) {
                dialog.isSources = true;
            }
            dialog.catalogModel = [];
            dialog.catalogModelCopy = [];
            dialog.vd = value.backup_versions[0].id;
            dialog.backupId = value.backup_versions[0].backupId;
            dialog.versionNum = value.backup_versions[0].versionNum;
            return;
        },
        //打开查看日志弹窗
        viewLogsOpen(item) {
            if(item.lowerType == 105) {
                return;
            }
            //打开日志弹窗
            this.viewNormalLogsOpen(item);
        },
        //打开查看日志弹窗
        viewNormalLogsOpen(item) {
            let that = this;
            item.viewed = true;
            this.operateMenuIndex = -1;
            this.$refs.viewLogsDialog.loading = true;
            this.$refs.viewLogsDialog.taskId = item.id;
            this.$refs.viewLogsDialog.typeId = item.lowerType;
            this.$refs.viewLogsDialog.viewLogsShow = true;
            if(item.lowerType == 104) {
                //如果是企业传输需要传入任务名
                this.$refs.viewLogsDialog.taskName = item.name;
            }
            console.log(item);
            if(item.result != -1 && item.lowerType == 105) {
                //离线下载直接传入
                that.$refs.viewLogsDialog.loading = false;
                that.$refs.viewLogsDialog.viewDetail = item;
            }else if (item.branchType == 'realtime') {
                var getData;
                if (item.isMultiTask) {
                    getData = new taskListUtils.getTasks(commonUtils.getUser().id, item.type, null, item.id);
                } else {
                    getData = new taskListUtils.getTasks(commonUtils.getUser().id, item.type, item.id, null);
                }
                this.Utils.doRealtimeSyncRequest("get", getData).then(result => {
                    if (result.message == 'success') {
                        console.log(result.data)
                        if(result.data) {
                            that.$refs.viewLogsDialog.viewDetail = result.data;
                            item.taskDetail = result.data;
                            
                        }else {
                            that.$toast({
                                text: that.$t('language.common.taskNotRun'),
                                type: 'fail',
                                idValue: "rightContBan"
                            });
                        }
                    } else {
                        that.$toast({
                            text: result.msg,
                            type: 'fail',
                            idValue: "rightContBan"
                        });
                        return;
                    }
                    that.$refs.viewLogsDialog.loading = false;
                });
            }else if (!item.taskDetail || (item.result != -1) || item.retransfer) {
                this.$refs.viewLogsDialog.loading = true;
                var getData;
                if (item.isMultiTask&&item.type!=6) {
                    //备份任务多源无需gd
                    getData = new taskListUtils.getTasks(commonUtils.getUser().id, item.type, null, item.id);
                } else {
                    getData = new taskListUtils.getTasks(commonUtils.getUser().id, item.type, item.id, null);
                }
                if (item.retransfer || (!item.taskDetail && item.result && item.result == 0)) {
                    let t = setTimeout(() => {
                        this.Utils.doTasksRequest("get", getData).then(result => {
                            if (result.status == 200) {
                                console.log(result.data)
                                that.$refs.viewLogsDialog.viewDetail = result;
                                item.taskDetail = result;
                            }else {
                                that.$refs.viewLogsDialog.viewDetail = null;
                                that.$toast({
                                    text: result.msg,
                                    type: 'fail',
                                    idValue: "rightBodyList"
                                });
                            }   
                            that.$refs.viewLogsDialog.loading = false;
                        });
                        clearTimeout(t);
                    }, 4000);
                } else {
                    this.Utils.doTasksRequest("get", getData).then(result => {
                        if (result.status == 200) {
                            console.log(result)
                            that.$refs.viewLogsDialog.viewDetail = result;
                            item.taskDetail = result;
                        }else {
                            that.$refs.viewLogsDialog.viewDetail = null;
                            that.$toast({
                                text: result.msg,
                                type: 'fail',
                                idValue: "rightBodyList"
                            });
                        }  
                        that.$refs.viewLogsDialog.loading = false;
                    });
                }
            } else {
                that.$refs.viewLogsDialog.viewDetail = item.taskDetail;
                that.$refs.viewLogsDialog.loading = false;
            }
            this.$forceUpdate();
        },
        //打开付费提示弹窗
        runNowShow(){
            this.showUpgrade(2);
            this.switchTypeFlag = true;
            this.executeFlag = true;
        },
        //显示schedule弹框
        openSchduleDialog(itemValue, index) {
            this.$refs.transferScheduleDialog.openPopup(itemValue, index);
        },
        //打开付费提示弹窗
        showUpgrade(type) {
            this.$refs.upgradeDialog.isShow = true;
            switch (type) {
                case 2:
                    this.$refs.upgradeDialog.doubleRealTimeShow = true;
                    break;
                case 3:
                    this.$refs.upgradeDialog.scheduledShow = true;
                    break;
                default:
                    break;
            }
        },
        //执行任务
        executeTask(item,callback) {
            //清除进度记录
            this.$store.commit('removeTaskProgress', item.id);
            
            var index = this.taskListOriginal.findIndex(t => t.id === item.id);
            if (item.branchType == 'businessTransfer') {
                this.executeBusinessTask(item, callback);
                return;
            }
            if (item.branchType == "realtime") {
                this.runRealTimeTask(item, callback);
                return;
            }
            let that = this;
            this.$forceUpdate();
            if (this.executeFlag) {
                this.executeFlag = false;
                let taskId;
                item.percent = 0;
                let that = this;
                let user = commonUtils.getUser();
                var executeData;
                if (item.isMultiTask) {
                    executeData = new taskListUtils.executeData(user.id, item.type, null, item.id);
                } else {
                    executeData = new taskListUtils.executeData(user.id, item.type, item.id, null);
                }
                let allData = this.taskListOriginal;
                let syncArr = [];
                let backupArr = [];
                for (let i = 0; i < allData.length; i++) {
                    if (allData[i].type == 2 && (allData[i].status == 1 || allData[i].status == 2) && allData[i].branchType != "realtime") {
                        //获取正在运行的普通同步任务
                        syncArr.push(allData[i]);
                    }
                    if (allData[i].type == 6 && (allData[i].status == 1 || allData[i].status == 2)) {
                        backupArr.push(allData[i]);
                    }
                }
                // if(backupArr.length >= 1){
                //    this.$toast({
                //       text: this.$t('language.cloudBackup.oneBackup'),
                //       type: 'fail',
                //       idValue: "rightBodyList"
                //     });
                //     this.executeFlag = true;
                //     return false;
                // }
                //非会员用户不能同时执行两个同步任务，但是可以执行两个传输任务，或者一个同步，一个传输任务
                if (!user.vip && syncArr.length >= 1 && item.type == 2) {
                    var upgradeNewDialog = this.$refs.upgradeDialog;
                    upgradeNewDialog.title = this.$t('language.paySystem.freePlanPopup.title_sync');
                    upgradeNewDialog.curItem = 'sync';
                    upgradeNewDialog.isShow = true;
                    this.executeFlag = true;
                    callback();
                    return;
                }
                let usedTraffic = user.usedBytes;
                //流量不足弹窗提醒
                if (user.vip && user.payLevel > 1) {
                    usedTraffic = user.payUsedTraffic;
                }
                if (user.totalBytes != -1 && usedTraffic >= user.totalBytes) {
                    var upgradeNewDialog = this.$refs.upgradeDialog;
                    upgradeNewDialog.title = this.$t('language.paySystem.freePlanPopup.title_traffic');
                    upgradeNewDialog.curItem = 'traffic';
                    upgradeNewDialog.isShow = true;
                    this.executeFlag = true;
                    callback();
                    return;
                }
                //邮件传输次数不足弹窗提醒
                if(item.options.way=='cloudEmail'&&!user.vip&&user.usageCount>=user.totalCount){
                    var upgradeNewDialog = this.$refs.upgradeDialog;
                    upgradeNewDialog.title = this.$t('language.paySystem.freePlanPopup.title_pdf');
                    upgradeNewDialog.curItem = 'pdf';
                    upgradeNewDialog.isShow = true;
                    this.executeFlag = true;
                    callback();
                    return;
                }
                item.updateFlag = true;
                this.taskListOriginal[index].updateFlag = true;
                this.Utils.doTasksRequest("execute", executeData).then(res => {
                    that.executeFlag = true;
                    if (item.type == 6) {
                        delete item.tranferWay;
                    }
                    if (res.status == 200) {
                        item.status = 2;
                        that.taskListOriginal[index] = item;
                        // 启动更新任务进度定时列表
                        that.$refs.taskListProgressControlModule.detectingTaskStatus();
                    } else {
                        this.$toast({
                            text: res.msg,
                            type: 'fail',
                            idValue: "rightBodyList"
                        });
                    }
                    callback();
                });
            }
        },
        runRealTimeTask(item,callback) {
            if (!this.switchTypeFlag) {
                callback();
                return;
            }
            var index = this.taskListOriginal.findIndex(t => t.id === item.id);
            let that = this;
            let realTimeArr = [];
            let syncArr = [];
            let user = commonUtils.getUser();
            let allData = this.$store.state.taskListArr;
            for (let i = 0; i < allData.length; i++) {
            if (allData[i].branchType == 'realtime' && (allData[i].status == 'Run' || allData[i].status == 'Init')) {
                realTimeArr.push(allData[i]);
            }
            for (let i = 0; i < allData.length; i++) {
                if (allData[i].type == 2 && (allData[i].status == 'Running' || allData[i].status == 'Waiting')) {
                syncArr.push(allData[i]);
                }
            }
            }
            this.switchTypeFlag = false;
            //非会员用户不能同时执行两个同步任务，但是可以执行两个传输任务，或者一个同步，一个传输任务
            if (!user.vip && realTimeArr.length >= 1 && item.branchType == 'realtime') {
                var upgradeNewDialog = this.$refs.upgradeDialog;
                upgradeNewDialog.title = this.$t('language.paySystem.freePlanPopup.title_real');
                upgradeNewDialog.curItem = 'real';
                upgradeNewDialog.isShow = true;
                this.switchTypeFlag = true;
                this.executeFlag = true;
                callback();
                return false;
            }
            //取消限制
            if (user.vip && (realTimeArr.length >= 2 && syncArr.length >= 2)) {
                that.$toast({
                    text: this.$t('language.exception.taskRunningNumberLimited'),
                    type: 'fail',
                    idValue: "rightBodyList"
                });
                this.switchTypeFlag = true;
                this.executeFlag = true;
                callback();
                return false;
            }
            let runData = {
                id: item.id,
                ud: commonUtils.getUser().id,
            }
            this.taskListOriginal[index].updateFlag = true;
            this.Utils.doRealtimeSyncRequest('switch_status', runData).then(res => {
                that.switchTypeFlag = true;
                that.executeFlag = true;
                if (res.message == 'success') {
                    item.status = res.data.status;
                    that.taskListOriginal[index] = item;
                    that.$refs.taskListProgressControlModule.detectingTaskStatus();
                    callback();
                    return false;
                } else {
                    if(!user.vip && res.reason=="taskRunningNumberLimited"){
                        var upgradeNewDialog = that.$refs.upgradeDialog;
                        upgradeNewDialog.title = this.$t('language.paySystem.freePlanPopup.title_real');
                        upgradeNewDialog.curItem = 'real';
                        upgradeNewDialog.isShow = true;
                        callback();
                        return false;
                    }
                    that.$toast({
                        text: this.$t('language.exception.' + res.reason),
                        type: 'fail',
                        idValue: "rightBodyList"
                    });
                    callback();
                    return false;
                }
            });
        },
        //执行企业传输任务
        executeBusinessTask(item, callback) {
            var index = this.taskListOriginal.findIndex(t => t.id === item.id);
            var data = {
                id: item.id,
                ud: commonUtils.getUser().id
            }
            var that = this;
            this.Utils.doBusinessTransferRequest('execute', data).then(res => {
                if (res.message == 'success') {
                    //获取该任务最新信息
                    item.status = res.data.status;
                    that.taskListOriginal[index] = item;
                    that.$refs.taskListProgressControlModule.detectingTaskStatus();
                } else {
                    that.reason(res.reason);
                }
                callback();
            }).catch(err =>{
                if (err.reason) {
                    err = that.$t('language.exception.' + err.reason)
                }
                that.$toast({
                    text: err,
                    type: 'fail',
                    idValue: "rightContBan"
                });
                callback();
            });

        },
        //关闭或暂停任务
        cancelOrPauseTask(item,callback) {
            var that = this;

            //进入关闭状态
            item.isCanceling = true;

            if(item.type == 2 && item.branchType == "realtime") {
                //暂停即时同步任务
                let stopData = {
                    id: item.id,
                    ud: commonUtils.getUser().id,
                }
                this.Utils.doRealtimeSyncRequest('switch_status', stopData).then(res => {
                    if (res.message == 'success') {
                        //如果是成功，提前设置为关闭状态
                        item.status = 0;
                        //获取该任务最新信息
                        that.initTaskListPage();
                    } else {
                        that.reason(res.reason);
                        //退出关闭状态
                        item.isCanceling = false;
                    }
                    callback();
                });
            }else if(item.type == 6) {
                //关闭备份任务
                let cancelData = new taskListUtils.cancelIdData(commonUtils.getUser().id, item.type, item.id, item.id);
                this.Utils.doTasksRequest('cancel', cancelData).then(res => {
                    if (res.message == 'success') {
                        //如果是成功，提前设置为关闭状态
                        item.status = 0;
                        //获取该任务最新信息
                        that.initTaskListPage();
                    } else {
                        that.reason(res.reason);
                        //退出关闭状态
                        item.isCanceling = false;
                    }
                    callback();
                })
            }else if(item.type == 1 && item.branchType == "businessTransfer") {
                //关闭企业传输服务
                var data = {
                    id: item.id,
                    ud: commonUtils.getUser().id
                }
                var that = this;
                this.Utils.doBusinessTransferRequest('cancel', data).then(res => {
                    if (res.message == 'success') {
                        //如果是成功，提前设置为关闭状态
                        item.status = 0;
                        //获取该任务最新信息
                        that.initTaskListPage();
                    } else {
                        that.reason(res.reason);
                        //退出关闭状态
                        item.isCanceling = false;
                    }
                    callback();
                })
            }else {
                //关闭其他任务
                let workId = item.id;
                if(item.workId) {
                    workId = item.workId;
                }
                let cancelData;
                if (item.isMultiTask) {
                    cancelData = new taskListUtils.cancelGdData(commonUtils.getUser().id, item.type, item.id, workId);
                } else {
                    cancelData = new taskListUtils.cancelIdData(commonUtils.getUser().id, item.type, item.id, workId);
                }
                this.Utils.doTasksRequest('cancel', cancelData).then(res => {
                    if (res.status == 200 || res.reason == 'notFoundTask') {
                        if(res.status == 200) {
                            //如果是成功，提前设置为关闭状态
                            item.status = 0;
                        }
                        //获取该任务最新信息
                        that.initTaskListPage();
                    } else {
                        that.reason(res.reason);
                        //退出关闭状态
                        item.isCanceling = false;
                    }
                    callback();
                });
            }
        },
        //提示错误
        showErrorTips(reason) {
            this.$toast({
                text: that.$t('language.exception.' + reason),
                type: 'fail',
                idValue: "rightBodyList"
            });
        },
        //跳转到源目录
        toSourceCatalog(sourceData,type) {
            let folderId;
            let fileName;
            let that = this;
            let leng = sourceData.nodes.length;
            console.log(sourceData)
            //如果是分享
            if(sourceData.driveType=="Shares") {
                window.open(sourceData.shareUrl);
                return;
            }
            //刷新用户流量
            commonUtils.refreshUserInfo(this.$parent.$parent, function(res) {});
            let driveId;
            this.$store.state.openFileFlag = false; //将云盘管理界面是否打开文件置为否
            if (sourceData.driveId) {
                driveId = sourceData.driveId;
            } else {
                driveId = sourceData.nodes[0].tokenId;
            }
            //若源为云盘根目录,点击后直接打开云盘根目录,子账号
            if (leng <= 1 || type == 104) {
                folderId = sourceData.id;
                fileName = sourceData.name;
                if (!folderId) {
                    folderId = sourceData.fileId;
                    fileName = sourceData.fileName;
                }
            } else {
            //若源为云盘子文件夹/文件，点击后直接在上一级目录选中该文件夹
                folderId = sourceData.nodes[1].fileId;
                if (sourceData.nodes[1].filename) {
                    fileName = sourceData.nodes[1].filename;
                } else {
                    fileName = sourceData.nodes[1].fileName;
                }
            }
            let pathData = this.$store.state.pathJson[folderId + driveId];
            this.encapsulationPath(sourceData, pathData);
            this.selectOption(sourceData);
            var storeFileId;
            storeFileId = sourceData.id;
            if (!sourceData.id) {
                storeFileId = sourceData.fileId;
            }
            if (!type) {
                that.$store.commit("setCatalogFileId", storeFileId);
            }
            this.$store.commit('setleftbannerMenuClick', driveId);
            if(commonstate.emailClouds.includes(sourceData.driveType)) {
                this.$router.push({
                    name: "emailExploer",
                    query: {
                        cloudType: sourceData.driveType,
                        folderId: folderId,
                        folderName: fileName,
                        tokenId: driveId,
                        docType: sourceData.docType,
                        queryParameter: sourceData.queryParameter
                    }
                });
            }else{
                this.$router.push({
                    name: "cloudExploer",
                    query: {
                    cloudType: sourceData.driveType,
                    folderId: folderId,
                    folderName: fileName,
                    tokenId: driveId
                    }
                });
            }
        },
        //跳转到目标云盘的目录
        toAimCatalog(aimData,type) {
            if (type == 104) {
                aimData.id = aimData.nodes[aimData.nodes.length - 1].fileId;
                aimData.name = aimData.nodes[aimData.nodes.length - 1].fileName;
            }
            console.log(aimData)
            //刷新用户流量
            commonUtils.refreshUserInfo(this.$parent.$parent, function(res) {});
            let that = this;
            let folderId = aimData.id;
            if (!folderId) {
                folderId = aimData.fileId;
            }
            let fileName = aimData.name;
            this.$store.state.openFileFlag = false; //将云盘管理界面是否打开文件置为否
            let driveId;
            if (aimData.driveId) {
                driveId = aimData.driveId;
            } else {
                driveId = aimData.nodes[0].tokenId;
            }
            let pathData = this.$store.state.pathJson[folderId + driveId];
            this.encapsulationPath(aimData, pathData);
            this.selectOption(aimData);
            if (type == 102) {
                let listData = new cloudExploerUtils.filelistData(aimData.id, commonUtils.getUser().id, driveId);
                commonUtils.toItemDataRefreshQuest(listData, this.item, function(res) {});
            }
            this.$store.commit('setleftbannerMenuClick', driveId);
            this.$router.push({
                name: "cloudExploer",
                query: {
                    cloudType: aimData.driveType,
                    folderId: folderId,
                    folderName: fileName,
                    tokenId: driveId
                }
            });
        },
        //选择左边的云盘
        selectOption(sourceData) {
            let dom;
            let rootDir;
            let that = this;
            let driveId;
            if (sourceData.driveId) {
                driveId = sourceData.driveId;
            } else {
                driveId = sourceData.nodes[0].tokenId;
            }
            $.each(that.$parent.$children, function(i, item) {
                if (item.menuOptions) { //如果是left_banner组件
                    dom = that.$parent.$children[i];
                    return;
                }
            });
            let clouds = dom.clouds;
            $.each(clouds, function(i, item) {
                if (driveId == item.id) {
                    dom.driveOptionSelect(i);
                    return false;
                }
            });
        },
        //如果没有path，则封装Path数据
        encapsulationPath(sourceAimData, pathData) {
            let that = this;
            let driveId;
            that.pathJson = [];
            if (sourceAimData.driveId) {
                driveId = sourceAimData.driveId;
            } else {
                driveId = sourceAimData.nodes[0].tokenId;
            }
            if (!pathData) {
                for (let i = sourceAimData.nodes.length - 1; i >= 0; i--) {
                    let name;
                    if (sourceAimData.nodes[i].fileName) {
                        name = sourceAimData.nodes[i].fileName;
                    } else {
                        name = sourceAimData.nodes[i].filename;
                    }
                    that.pathJson.push({
                        id: sourceAimData.nodes[i].fileId,
                        name: name,
                        driveId: driveId
                    });
                    let JsonList = Object.assign([], that.pathJson);
                    that.$store.commit("setPathJson", {
                        folderId: sourceAimData.nodes[i].fileId + driveId,
                        json: JsonList
                    });
                }
            }
        },
        //修改设置信息
        updateOptionRequest(itemData) {
            let that = this;
            var updateData;
            let schedules = itemData.schedules;
            schedules.clientTime = commonUtils.getNowDateFormat();
            let options = itemData.options;
            let getData;
            //企业传输接口不允许使用gd
            if (itemData.isMultiTask&&itemData.lowerType != 104) {
                let gd = itemData.id;
                updateData = {
                    gd: gd,
                    ud: commonUtils.getUser().id,
                    type: itemData.type,
                    n: itemData.name,
                    options: options,
                    schedules: schedules
                }
            } else {
                let id = itemData.id;
                updateData = {
                    id: id,
                    ud: commonUtils.getUser().id,
                    type: itemData.type,
                    n: itemData.name,
                    options: options,
                    schedules: schedules
                }
            }
            that.taskSchduleShow = false;
            if(itemData.lowerType != 104){
                this.Utils.doTasksRequest("update", updateData).then(result => {
                    if (result.status == 200) {
                        if (itemData.isMultiTask) {
                            getData = {
                                ud: commonUtils.getUser().id,
                                type: itemData.type,
                                gd: itemData.id
                            }
                        } else {
                            getData = {
                                ud: commonUtils.getUser().id,
                                type: itemData.type,
                                id: itemData.id,
                            }
                        }
                        that.Utils.doTasksRequest("get", getData).then(res => {
                            let newTask = that.taskListOriginal.find(item => item.id == itemData.id);
                            newTask.schedules = res.tasks[0].schedules;
                            newTask.options = options;
                            that.$refs.taskListProgressControlModule.getTimedExecution(newTask);
                            console.log(newTask);
                        });
                    } else {
                        this.$toast({
                            text: this.$t('language.exception.' + result.reason),
                            type: 'fail',
                            idValue: "rightBodyList"
                        });
                    }
                });
            }else{
                delete updateData.type;
                this.Utils.doBusinessTransferRequest("update", updateData).then(result => {
                    let data = that.taskListOriginal.find(item => item.id == itemData.id);
                    data.schedules = schedules;
                    data.options = options;
                    if(data.sources){
                        for(var i=0;i<data.sources.length;i++){
                            data.sources[i].options=options;
                            data.sources[i].schedules=schedules;
                        }
                    }
                    that.$refs.taskListProgressControlModule.getTimedExecution(data);
                }).catch(err =>{
                    if (err.reason) {
                        err = that.$t('language.exception.' + err.reason)
                    }
                    that.$toast({
                        text:err,
                        type: 'fail',
                        idValue: "rightBodyList"
                    });
                });
            }
        },
        //更新任务信息
        updateTaskItem(newTask) {
            let index = this.taskListOriginal.findIndex(t => t.id === newTask.id);
            if(index) {
                this.taskListOriginal[index] = newTask;
                this.$refs.taskListProgressControlModule.detectingTaskStatus();
            }
        },
        //更新任务信息
        getOneTaskItem(task) {
            let getData;
            let userId = commonUtils.getUser().id;
            var that = this;
            if(task.lowerType == 104) {
                //如果是企业传输任务
                this.Utils.doBusinessTransferRequest("get", {id: task.id,ud: userId}).then(res => {
                    //获取详情并拼装
                    if (res.tasks) {
                        let businessTasks = taskListConvert.getBusinessTasks(res.tasks);
                        if(businessTasks.length>0) {
                            that.updateTaskItem(businessTasks[0]);
                        }
                    }
                })
            }else if(task.lowerType == 102 && task.branchType == "realtime") {
                //如果是即时同步任务
                if (task.isMultiTask) {
                    getData = new taskListUtils.getTasks(userId, task.type, null, task.id);
                } else {
                    getData = new taskListUtils.getTasks(userId, task.type, task.id, null);
                }
                this.Utils.doRealtimeSyncRequest("get", getData).then(res => {
                    //获取详情并拼装
                    if (res.message == 'success') {
                        let syncTasks = res.data.tasks;
                        let newTasks = taskListConvert.getSyncTasks(syncTasks,syncTasks);
                        if(newTasks.length>0) {
                            that.updateTaskItem(newTasks[0]);
                        }
                    }    
                });
            }else {
                if (task.isMultiTask) {
                    getData = new taskListUtils.getTasks(userId, task.type, null, task.id);
                } else {
                    getData = new taskListUtils.getTasks(userId, task.type, task.id, null);
                }
                this.Utils.doTasksRequest("get", getData).then(res => {
                    //获取详情并拼装
                    if (res.status == 200) {
                        let type = res.tasks[0].type;
                        let newTasks;
                        switch (type) {
                            case 1:
                                newTasks = taskListConvert.getTransferTasks(res.tasks);
                                break;
                            case 2:
                                newTasks = taskListConvert.getSyncTasks(res.tasks,[]);
                                break;
                            case 3:
                                newTasks = taskListConvert.getOfflinesTasks(res.tasks);
                                break;
                            case 6:
                                newTasks = taskListConvert.getBackupTasks(res.tasks);
                                break;
                            default:
                                break;
                        }
                        if(newTasks.length>0) {
                            that.updateTaskItem(newTasks[0]);
                        }
                    }
                });
            }
        },
        reason(reson) {
            this.$toast({
                text: that.$t('language.exception.' + reson),
                type: 'fail',
                idValue: "rightContBan"
            });
        }
    },
    computed: {
        filteredList() {
            let param = {};
            console.log(this.freeFilterDateList)
            if(this.filterDate == 304 && this.freeFilterDateList){
                //自定义条件过滤
                let min = this.conversionLongTime(this.freeFilterDateList[0]);
                let max = this.conversionLongTime(this.freeFilterDateList[1]);
                let maxLongAdd = this.conversionMaxLongTime(this.freeFilterDateList[1]);
                let that = this;
                if (min > max) {
                    this.$toast({
                        text: that.$t('language.taskList.timeMustLess'),
                        type: 'fail',
                        idValue: "rightBodyList"
                    });
                    return;
                }else {
                    param.date = {
                        min: min,
                        max: maxLongAdd
                    }
                }
            }

            var filterArr = [this.filterType,this.filterState,this.filterDate];
            //任务列表过滤
            let res = taskFilter.filterByArr(this.taskListOriginal,filterArr,param);
            return res;
        },
        showList() {
            var res;
            var pageNum = (this.pageIndex * this.pageSize);
            if(this.filteredList.length > pageNum) {
                res = this.filteredList.slice(0,pageNum);
            }else {
                res = this.filteredList;
            }
            return res;
        }
    }
}
</script>

<style scoped>
.right-body {
    background: url("../../assets/images/workspace/task.png") no-repeat bottom / 100% auto,#D8D8D8;
}

.right-body-box {
    position: relative;
    margin: 0 50px;
    /*no*/
    padding: 50px 0;
    /*no*/
    height:100%;
}

.task-list-initial {
    height: calc(100% - 140px);
    /*no*/
    text-align: center;
    margin: 30px 0;
    /*no*/
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.task-list-initial strong{
    margin-top: 40px;
    /*no*/
    font-size: 24px;
    /*no*/
    letter-spacing: 0em;
    color: #333333;
}

.task-list-initial span{
    margin-top: 10px;
    /*no*/
    font-size: 16px;
    /*no*/
    font-weight: normal;
    line-height: normal;
    letter-spacing: 0em;
    color: #6F6F6F;
}

.task-list-functions {
    position: absolute;
    right: 0;
    top: 35px;
    /*no*/
    display: flex;
    align-items: center;
    justify-content: center;
}

.icon-function {
    width: 16px;
    /*no*/
    height: 16px;
    /*no*/
    top: 0;
    margin-right: 20px;
    /*no*/
}

.task-list-switch-tab {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 26px;
    /*no*/
    border: solid 1px #C1CBE3;
    /*no*/
    border-radius: 4px;
    /*no*/
}

.task-list-switch-tab .icon-switch-tab div{
    margin: 3px 10px;
    /*no*/
}

.icon-switch-tab-this {
    background: #5562B4;
}

.filter-menu {
    position: absolute;
    z-index: 600;
    background: #fff;
    width: 100Px;
    /*no*/
    border: 1Px solid #8a96e3;
    /*no*/
    right: 10px;
    /*no*/
    top: 10px;
    /*no*/
}

.filter-menu-item {
    width: 100%;
    height: 33.3Px;
    /*no*/
    line-height: 33Px;
    /*no*/
}

.type-menu {
    min-width: 200Px;
    /*no*/
    border: 1Px solid #8a96e3;
    /*no*/
    position: absolute;
    background: #fff;
    right: 100Px;
    /*no*/
    top: -1px;
    /*no*/
    z-index: 300 !important;
}

.type-menu-item {
    width: 100%;
    height: 34Px;
    /*no*/
    line-height: 34Px;
    /*no*/
    position: relative;
}

.filter-menu-item:hover,
.type-menu-item:hover,
.operate-menu-item:hover {
    background: #d9e7ff;
    cursor: pointer;
}

.filter-type-name {
    margin: 0 10Px 0 25Px;
    /*no*/
    float: left;
}

.filter-triangle-position {
    position: relative;
    top: 6Px;
    /*no*/
    margin-right: 10Px;
    /*no*/
}

.tick-purple-position {
    float: left;
    position: relative;
    top: 10Px;
    /*no*/
    left: 17Px;
    /*no*/
    width: 15Px;
    /*no*/
    height: 15Px;
    /*no*/
}

.time-set {
  width: 425Px;
  /*no*/
  height: 50Px;
  /*no*/
  position: absolute;
  z-index: 3;
  background: #fff;
  border: 1Px solid #8a96e3;
  /*no*/
  right: 0;
}

.arrow-purple-position {
  float: left;
  margin: 12Px 10Px;
  /*no*/
}

.time-set-button {
  margin-top: 10Px;
  /*no*/
}

.task-list-tab-titles {
    display: flex;
    align-items: center;
    justify-content: left;
    font-family: Arial;
    font-size: 18px;
    /*no*/
    font-weight: bold;
    line-height: normal;
    letter-spacing: 0em;
    color: #333333;
    box-sizing: border-box;
    border-width: 0px 0px 1px 0px;
    /*no*/
    border-style: solid;
    border-color: #C1CBE3;
}

.task-list-tab-title {
    display: flex;
    flex-direction: column;
    height: 30px;
    /*no*/
    margin-right: 40px;
    /*no*/
    cursor: pointer;
}

.task-list-tab-title.tab-this{
    color: #5562B4;
    margin-bottom: -3px;
    /*no*/
    border-width: 0px 0px 3px 0px;
    /*no*/
    border-style: solid;
    border-color: #5562B4
}

.task-list-tab-content {
    width: calc(100% + 45px);
    /*no*/
    height: calc(100% - 110px);
    /*no*/
    margin-bottom: 0px;
    /*no*/
    margin-top: 30px;
    /*no*/
    box-sizing: border-box;
    font-family: Arial;
    font-size: 14px;
    /*no*/
    font-weight: normal;
    line-height: normal;
    letter-spacing: 0em;
}

.task-filter-none {
    background: #FFFFFF;
    box-sizing: border-box;
    border: 1px solid #C1CBE3;
    /*no*/
}
/** 
    卡片
*/

.grid-col-fiction {
    margin-bottom: 0px;
    /*no*/
    margin-left: 32px;
    /*no*/
    position: relative;
    max-width: 768px;
    /*no*/
    min-width: 532px;
    /*no*/
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: 0;
}

/** 
    列表
*/

.task-list-grid {
    padding: 0 40px 0 0;
    /*no*/
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
}

.task-list-grid::-webkit-scrollbar,
.task-list-list::-webkit-scrollbar {
    width: 8Px;
    /*no*/
    height: 8Px;
    /*no*/
    background-color: #fff;
    position: absolute;
    z-index: 700;
}

.task-list-grid::-webkit-scrollbar-thumb,
.task-list-list::-webkit-scrollbar-thumb {
    height: 1Px;
    /*no*/
    border-radius: 5Px;
    /*no*/
    background-color: #becae4;
    position: absolute;
    z-index: 700;
}

.list:hover:after {
  content: attr(data-title);
  position: fixed;
  border: #8a96e3 solid 1px;
  /*no*/
  background: #fff;
  position: absolute;
  top: 30px;
  /*no*/
  left: 95px;
  /*no*/
  font-size: 13px;
  /*no*/
  color: rgba(0, 0, 0, 0.6);
  padding: 2px;
  /*no*/
  border-radius: 2px;
  /*no*/
  z-index: 600;
  white-space: nowrap;
}

.grid:hover:after {
  content: attr(data-title);
  position: fixed;
  border: #8a96e3 solid 1px;
  /*no*/
  background: #fff;
  position: absolute;
  top: 30px;
  /*no*/
  left: 95px;
  /*no*/
  font-size: 13px;
  /*no*/
  color: rgba(0, 0, 0, 0.6);
  padding: 2px;
  /*no*/
  border-radius: 2px;
  /*no*/
  z-index: 3;
}

.loading-img {
    width: 96px;/*no*/
    height: 96px;/*no*/
}

.task-grid-cards {
    flex-wrap: wrap;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(500px, 1fr));/*no*/
    gap: 16px;/*no*/
    margin-bottom: 40px;/*no*/
}

#rightBodyList .loading-img >>> .el-loading-mask {
    background: transparent;
}
#rightBodyList .loading-img >>> .el-loading-spinner {
    top: 25px;/*no*/
}
#rightBodyList .loading-img >>> .el-loading-spinner .circular {
    width: 96px !important;/*no*/
    height: 96px !important;/*no*/
}
</style>


// WEBPACK FOOTER //
// src/components/workspace/task_list_new.vue